import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "../hooks/useAuth";
import {getAppVersion} from "../helpers.js";

const SentryContextProvider = ({ children }) => {
    const { user } = useAuth();

    useEffect(() => {
        if (!user) {
            Sentry.setUser(null);
            return;
        }

        const storage = Object.fromEntries(
            Object.keys(localStorage).map(key => [key, localStorage.getItem(key)])
        );

        const scope = Sentry.getCurrentScope();
        scope?.setUser({ id: user.username});
        scope?.setTag('version', getAppVersion());
        scope?.setExtra('storage', storage);

    }, [user]);

    return <>{children}</>;
};

export default SentryContextProvider;
